import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./TopProducts.gql";

export const useTopProducts = () => {
  const { getTopProducts } = DEFAULT_OPERATIONS;
  const { data } = useQuery(getTopProducts, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  const HomeTopProductsData = data && data.products ? data.products : "";
  return {
    HomeTopProductsData,
  };
};
